import React from "react";
import styles from "./barLegend.module.css";

// 87.0 -> "87%", 7.64 -> "7.6%"
const formatPercent = (value, total) => {
  if (!total) return "0%";
  return `${Number(((value / total) * 100).toFixed(1))}%`;
};

const BarLegend = ({ data = [], unit = "", onItemClick }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <ul className={styles.list}>
      {data.map((item) => {
        const width = total ? (item.value / total) * 100 : 0;

        return (
          <li
            key={item.id}
            className={`${styles.item} ${onItemClick ? styles.clickable : ""}`}
            onClick={() => onItemClick?.(item)}
          >
            <div className={styles.row}>
              <span
                className={styles.dot}
                style={{ background: item.color }}
              />
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>
                {item.value}
                {unit}
              </span>
              <span className={styles.percent}>
                {formatPercent(item.value, total)}
              </span>
            </div>

            <div className={styles.track}>
              <div
                className={styles.bar}
                style={{ width: `${width}%`, background: item.color }}
              />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default BarLegend;